module.exports = __webpack_public_path__ + "static/media/bar.1d172f9b.svg";